import { __rest } from "tslib";
const transformAddressComponents = (components) => {
    const keyedObject = {};
    components.forEach((component) => {
        component.types.forEach((type) => {
            if (type === 'political')
                return;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { types } = component, componentWithoutTypes = __rest(component, ["types"]);
            keyedObject[type] = componentWithoutTypes;
        });
    });
    return keyedObject;
};
export const transformResult = (input) => {
    const output = {
        addressComponents: {},
        formattedAddress: input.formatted_address,
        geometry: input.geometry,
        placeId: input.place_id,
        types: input.types,
    };
    output.addressComponents = transformAddressComponents(input.address_components);
    return output;
};
//# sourceMappingURL=helpers.js.map